import { render, staticRenderFns } from "./InformationBoard.vue?vue&type=template&id=7f91be70&lang=pug&"
import script from "./InformationBoard.vue?vue&type=script&lang=js&"
export * from "./InformationBoard.vue?vue&type=script&lang=js&"
import style0 from "./InformationBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports